// Lectura de archivos del usuario, con respaldo a FileReader para navegadores y entornos sin `Blob.text()`.

function viaReader<T extends string | ArrayBuffer>(read: (r: FileReader) => void): Promise<T> {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result as T);
    r.onerror = () => reject(r.error ?? new Error('No se pudo leer el archivo'));
    read(r);
  });
}

export function readText(file: Blob): Promise<string> {
  return typeof file.text === 'function' ? file.text() : viaReader<string>((r) => r.readAsText(file));
}

export async function readBytes(file: Blob): Promise<Uint8Array> {
  const buffer = typeof file.arrayBuffer === 'function' ? await file.arrayBuffer() : await viaReader<ArrayBuffer>((r) => r.readAsArrayBuffer(file));
  return new Uint8Array(buffer);
}
